export const getMyUser=()=>{
    const parse = JSON.parse(localStorage.getItem('user') as never)
    return parse
}